import Swal from "sweetalert2";

export function showAlert(title, icon) {
  return Swal.fire({
    title: title,
    icon: icon,
    showConfirmButton: false,
    timer: 2000,
  });
}

export function alertConfirm(text) {
  return Swal.fire({
    title: "Are you sure?",
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#34c38f",
    cancelButtonColor: "#f46a6a",
    confirmButtonText: "Yes",
  });
}

export function alertError(title) {
  return showAlert(title, "error");
}

export function alertSuccess(title) {
  return showAlert(title, "success");
}
